// extracted by mini-css-extract-plugin
export default {"fontStyrene":"a1M0w","externalFont":"b1M0w"};